import { Component, OnInit } from '@angular/core';
import { AuthService, LocationConfigService, PriceConfigService } from 'gung-standard';
import { JeevesOrderActionConfigService, JeevesOrderCardListComponent } from 'gung-standard-jeeves';
import { first } from 'rxjs';

@Component({
    selector: 'ref-ref-order-card-list',
    templateUrl: './ref-order-card-list.component.html',
    styleUrls: ['./ref-order-card-list.component.scss'],
    standalone: false
})
export class RefOrderCardListComponent extends JeevesOrderCardListComponent implements OnInit {
  isAdminOrSales: boolean = false;

  constructor(
    public configService: JeevesOrderActionConfigService,
    protected locationConfigService: LocationConfigService,
    protected authService: AuthService,
    public priceConfigService: PriceConfigService
  ) {
    super(
      configService,
      locationConfigService,
      priceConfigService
    );
  }

  ngOnInit() {
    this.authService.getRoles().pipe(first()).subscribe(roles => {
      this.isAdminOrSales = roles.includes('ADMIN') || roles.includes('SALES');
    });
  }
}
